import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import App from "./App";
import { wansightTheme, wansightThemeLight } from "./theme";
import { GeoSettingsProvider } from "./contexts/GeoSettingsContext";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import "antd/dist/reset.css";
import "./theme.css";

// ThemedConfigProvider picks the AntD ThemeConfig that matches the
// resolved (light/dark) effective theme so AntD's algorithm + tokens
// rebuild every time the user toggles.
function ThemedConfigProvider({ children }: { children: React.ReactNode }) {
  const { effective } = useTheme();
  const cfg = effective === "light" ? wansightThemeLight : wansightTheme;
  return <ConfigProvider theme={cfg}>{children}</ConfigProvider>;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ThemedConfigProvider>
        <BrowserRouter>
          <GeoSettingsProvider>
            <App />
          </GeoSettingsProvider>
        </BrowserRouter>
      </ThemedConfigProvider>
    </ThemeProvider>
  </React.StrictMode>
);
